import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=a00edf4c&scoped=true&"
import script from "./feedbackList.vue?vue&type=script&lang=js&"
export * from "./feedbackList.vue?vue&type=script&lang=js&"
import style0 from "./feedbackList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./feedbackList.vue?vue&type=style&index=1&id=a00edf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00edf4c",
  null
  
)

export default component.exports